import React, { useCallback, useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { handleApiError } from 'utils';
import { companiesListService } from 'services/company';
import { branchesListByCompanyIdService } from 'services/branch';
const { Option } = Select;

export default function CompanyBranchDropdownForm({ company, initialBranch }) {
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);
  const [isBranchLoading, setIsBranchLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [branches, setBranches] = useState([]);
  const [form] = Form.useForm();

  const loadBranches = useCallback(async (companyId) => {
    if (!companyId) {
      setBranches([]);
      return;
    }

    setIsBranchLoading(true);
    try {
      const response = await branchesListByCompanyIdService(companyId);
      if (response.data.items) {
        setBranches(response.data.items);
        if (initialBranch && companyId === company) {
          form.setFieldsValue({ branch: initialBranch });
        }
      }
    } catch (error) {
      handleApiError(error);
      setBranches([]);
    } finally {
      setIsBranchLoading(false);
    }
  });

  useEffect(() => {
    setIsCompanyLoading(true);
    companiesListService()
      .then((response) => {
        if (response.data.items && response.data.items.length > 0) {
          setCompanies(response.data.items);
          if (company) {
            form.setFieldsValue({ company: company });
          }
        }
      })
      .catch((err) => {
        handleApiError(err);
      })
      .finally(() => {
        setIsCompanyLoading(false);
      });
  }, [company, form]);

  useEffect(() => {
    if (company) {
      form.setFieldsValue({ company: company });
      loadBranches(company);
    }
  }, [company, form, initialBranch, loadBranches]);

  const onCompanyChange = (value) => {
    form.setFieldsValue({ branch: undefined });
    loadBranches(value);
  };

  return (
    <div
      style={{
        backgroundColor: '#FAFAFA',
        border: '1px solid #EAEAEA',
        padding: '30px 5px 5px 5px',
        marginBottom: 30,
      }}
    >
      {companies.length > 0 && (
        <Form.Item
          label="Company"
          name="company"
          rules={[{ required: true, message: 'Please select Company' }]}
        >
          <Select
            autoComplete="nope"
            showSearch
            placeholder="Select a company"
            optionFilterProp="children"
            onChange={(value) => onCompanyChange(value)}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            loading={isCompanyLoading}
          >
            <Option value="">Select a company</Option>
            {companies.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.company_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}
      {companies.length === 0 && !isCompanyLoading && (
        <Form.Item label="Company" name="company">
          <div style={{ background: 'yellow', padding: '2px' }}>
            Please contact admin to allow you company level permission
          </div>
        </Form.Item>
      )}
      <Form.Item
        label="Branch"
        name="branch"
        rules={[{ required: true, message: 'Please select Company & Branch' }]}
      >
        <Select
          autoComplete="nope"
          showSearch
          placeholder="Select a branch"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          loading={isBranchLoading}
        >
          <Option value="">Select a branch</Option>
          {branches.map((item) => (
            <Option key={item._id} value={item._id}>
              {item.branch_name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
}
